<fadv-layout>
    <fadv-layout-main>
      <div class='main'>
        <app-alert-message></app-alert-message>
        <router-outlet></router-outlet>
      </div>
    </fadv-layout-main>
</fadv-layout>
